const FEATURES = [
  {
    icon: "ri-shield-check-line",
    title: "品質保障",
    desc: "所有商品均為原廠正品，提供完整保固，讓您購物無後顧之憂。",
    bg: "from-[#1B4332] to-[#2D6A4F]",
  },
  {
    icon: "ri-truck-line",
    title: "全台免運",
    desc: "滿額免運費，快速到貨，最快隔日配達，讓您盡快享受新品。",
    bg: "from-[#2D6A4F] to-[#40916C]",
  },
  {
    icon: "ri-exchange-line",
    title: "7 天退換",
    desc: "七天無憂退換貨政策，不滿意全額退款，購物更放心。",
    bg: "from-[#40916C] to-[#52B788]",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "專業客服",
    desc: "專業客服團隊隨時待命，協助解決任何售前售後問題。",
    bg: "from-[#52B788] to-[#74C69D]",
  },
];

export default function BrandFeatures() {
  return (
    <section className="py-24 bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-xs tracking-widest text-zinc-400 uppercase mb-4">Why Choose Us</p>
          <h2 className="text-4xl md:text-5xl font-extralight text-[#1B4332] tracking-tight mb-5">
            為什麼選擇我們
          </h2>
          <div className="w-12 h-0.5 bg-[#1B4332] mx-auto mb-4" />
          <p className="text-zinc-400 text-base">四大核心優勢，帶給你最安心的購物體驗</p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {FEATURES.map((f) => (
            <div
              key={f.title}
              className={`relative bg-gradient-to-b ${f.bg} rounded-lg p-8 flex flex-col items-center text-center overflow-hidden group hover:-translate-y-1 transition-transform duration-300`}
            >
              {/* Icon */}
              <div className="w-16 h-16 flex items-center justify-center bg-white/10 rounded-full mb-6">
                <i className={`${f.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-white text-lg font-semibold mb-3">{f.title}</h3>
              <p className="text-white/60 text-sm leading-relaxed">{f.desc}</p>
              {/* Bottom dash */}
              <div className="absolute bottom-4 left-1/2 -translate-x-1/2 w-10 h-px bg-white/30" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
